import axios, { AxiosInstance } from 'axios';
import { appConfig } from '../../config/app-config';

export class BoldRApi {
    private apiKey: string;
    private token: string | null = null;
    private axiosInstance: AxiosInstance;

    constructor(apiKey: string) {
        this.apiKey = apiKey;
        this.axiosInstance = axios.create({
            baseURL: appConfig.boldr.baseUrl,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    async getToken(): Promise<string> {
        if (this.token) return this.token;

        try {
            const response = await this.axiosInstance.post('/generate-token', { client: 'all4logic' }, {
                headers: {
                    'x-api-key': this.apiKey
                }
            });
            this.token = response.data.token;
            return this.token || "";
        } catch (error) {
            console.error('Error retrieving the token:', error);
            throw new Error('Failed to retrieve authentication token');
        }
    }

    async uploadFile(file: File, transactionId: string): Promise<any> {
        try {
            const token = await this.getToken();

            const formData = new FormData();
            formData.append('file', file);
            const response = await this.axiosInstance.post('/upload', formData, {
                headers: {
                    'x-api-key': this.apiKey,
                    Authorization: `Bearer ${token}`,
                    'TransactionID': transactionId
                }
            });

            return response.data;
        } catch (error) {
            console.error('Error uploading the file:', error);
            throw new Error('Failed to upload the file to BoldR OCR');
        }
    }
}
